import {createSelector} from "reselect";
import {getAdminStoreState} from "../../store/admin-store-selectors";

export class OrpyxCareUsersStoreSelectors {
    static readonly state = createSelector(getAdminStoreState, state => state.orpyxCareUsers);
    static readonly list = createSelector(OrpyxCareUsersStoreSelectors.state, state => state.list);
    static readonly information = createSelector(OrpyxCareUsersStoreSelectors.state, state => state.information);
    static readonly confirmation = createSelector(OrpyxCareUsersStoreSelectors.state, state => state.confirmation);
}
